export function canReplyOrReact(item) {
  if (!item?.id || String(item.status).toLowerCase() === 'failed') return false;
  if (item.direction !== 'outbound') return true;
  return !item._optimistic && String(item.id).startsWith('msg_')
    && ['sent', 'delivered', 'read'].includes(String(item.status).toLowerCase());
}

// WATI discards sticker reply context. Reactions retain their normal eligibility.
export const canReplyToMessage = item => item?.kind !== 'sticker' && canReplyOrReact(item);

export const isMediaMessage = item => ['image', 'video', 'audio', 'document', 'sticker', 'gif', 'voice'].includes(item?.kind);
export function canDownloadMedia(item) {
  if (!isMediaMessage(item) || item.content?.redacted || item.content?.attachment?.verdict === 'blocked') return false;
  // An attachment ID is the canonical descriptor needed by the secure content loader.
  // Pending scan/preview state with a descriptor is not a reason to block a click.
  return Boolean(item._localFile || item.content?.attachment?.id);
}
